import React, { useState, useEffect, useRef, Fragment } from "react";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Dropdown from "react-bootstrap/Dropdown";
import toast, { Toaster } from "react-hot-toast";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import Swal from "sweetalert2";
import LinearProgress from "@mui/material/LinearProgress";
import ClearIcon from "@mui/icons-material/Clear";
import { useNavigate, Link, useParams } from "react-router-dom";
import {
    getInvoiceDetailsByUUID,
    getInvoicesList,
    logInvoiceHistory,
    addEInvoice,
    cancelEInvoice,
    getEInvoiceDetail,
    deleteInvoice,
    addCreditNote,
    editCreditNote,
    getCreditNote2,
    getTermsConditionKeyValue,
    getStateRegionKeyValuePair,
} from "../../../services/index";

import ViewPdf from "../../Common/ViewPdf";
import AddIcon from "@mui/icons-material/Add";
import PaymentIcon from "@mui/icons-material/Payment";
import CloseIcon from '@mui/icons-material/Close';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { TbArrowsDiagonal } from "react-icons/tb";
import { FaLink } from "react-icons/fa";
import { FcLink } from "react-icons/fc";

import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { generateEWay } from "../../../services/Sales/InvoiceServices";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { callPostApi } from "../../../services/common/common";
import { CANCEL_EWAY_BILL_POST, EXTEND_EWAY_BILL_POST, UPDATE_EWAY_VEHICLE_NUMBER_POST } from "../../../CONSTANTS";
import { confirmAlert } from "react-confirm-alert";
import { Spinner } from "react-bootstrap";
import CreditNoteView from "../creditNote/CreditNoteView";

const ewayBillCancelReasonOptions = [
    {
        label: "- Select Reason -",
        value: ""
    },
    {
        label: "Duplicate",
        value: "Duplicate"
    },
    {
        label: "Order Cancelled",
        value: "Order Cancelled"
    },
    {
        label: "Data Entry mistake",
        value: "Data Entry mistake"
    },
    {
        label: "Others",
        value: "Others"
    },
]

const updateVehicleEwayOptions = [
    {
        label: "- Select Reason -",
        value: ""
    },
    {
        label: "Due To Break Down",
        value: "Due To Break Down"
    },
    {
        label: "Due To Transhipment",
        value: "Due To Transhipment"
    },
    {
        label: "Others",
        value: "Others"
    },
]

const cancelEwayEmptyObj = {
    reason: {
        label: "- Select Reason -",
        value: ""
    },
    remark: ""
}

const updateVehicleEmptyObj = {
    vehicleNumber: "",
    reason: {
        label: "- Select Reason -",
        value: ""
    },
    placeOfChange: "",
    placeOfChangeState: ""
}



const extensionOptions = [
    {
        label: "Natural Calamity",
        value: "Natural Calamity",
    },
    {
        label: "Law & Order",
        value: "Law & Order",
    },
    {
        label: "Transhipment",
        value: "Transhipment",
    },
    {
        label: "Accident",
        value: "Accident",
    },
    {
        label: "Others",
        value: "Others",
    }
]
const consignmentOptions = [
    {
        label: "In Movement",
        value: "In Movement",
    },
    {
        label: "In Transit",
        value: "In Transit",
    }
]

const ExtendedEwayBillObj = {
    remark: "",
    reason: {
        label: "- Select Reason -",
        value: ""
    },
    currentPlace: "",
    currentPinCode: "",
    approximateDistance: "",
    vehicleNo: "",
    consignment: {
        label: "In Movement",
        value: "In Movement",
    },
    currentState: "",
}

const InvoiceView = (props) => {
    let { id } = useParams();
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);

    const [tabIndex, setTabIndex] = useState(0);
    const [loader, setLoader] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [showSpinner, setShowSpinner] = useState(false);

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => {
        setShow2(false);
        setCancelInfo({});
    };

    const [show3, setShow3] = useState(false);
    const handleClose3 = () => {
        setShow3(false);
        setEdit(false);
        setItemList([]);
    };

    const creditNoteItemTypeEnumOptions = [
        { label: "wastage", value: "wastage" },
        { label: "shorts", value: "shorts" },
        { label: "returns", value: "returns" },
    ]

    const [cancelInfo, setCancelInfo] = useState({});

    const [pdfOption, setPdfOption] = useState("");
    const [keys, setKeys] = useState("");
    const [values, setValues] = useState("");

    const [hsnKey, setHsnKey] = useState("");
    const [hsnVal1, setHsnVal1] = useState("");
    const [hsnVal2, setHsnVal2] = useState("");

    const [taxType, setTaxType] = useState("");
    const [orgDetail, setOrgDetail] = useState("");
    const [logData, setLogData] = useState({});

    const [invoiceOrdersList, setInvoiceOrdersList] = useState([]);
    const [invoiceOrderDetail, setInvoiceOrderDetail] = useState(null);
    const [edit, setEdit] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [invDetails, setInvDetails] = useState([]);
    const [creditInfo, setCreditInfo] = useState({
        date: date1,
        terms: "",
        note: "",
        cNo1: "",
        creditNoteItemTypeEnum: { label: "wastage", value: "wastage" },
    });
    const [termsOptions, setTermsOptions] = useState([]);
    const [batchDetails, setBatchDetails] = useState([])
    let orgDetails = JSON.parse(localStorage.getItem("orgDetail"));
    let orgState = orgDetails?.beanAddress?.state;

    // const [creditNoteItemTypes, setCreditNoteItemTypes] = useState(
    //     itemList.map(() => ({
    //         date: date1,
    //         terms: "",
    //         note: "",
    //         cNo1: "",
    //         creditNoteItemTypeEnum: { label: "wastage", value: "wastage" },
    //     }))
    // );

    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [invoiceOrdersListDetails, setInvoiceOrdersListDetails] = useState(null);
    const [ewayModal, setEwayModal] = useState(false);
    const [vehicleNumber, setVehicleNumber] = useState("");
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [showExtendedEwayBill, setShowExtendedEwayBill] = useState(false);
    const [cancelEwayObj, setCancelEwayObj] = useState(cancelEwayEmptyObj)
    const [updateVehicleObj, setUpdateVehicleObj] = useState(updateVehicleEmptyObj)
    const [reasonForExtension, setReasonForExtension] = useState(ExtendedEwayBillObj)

    const [stateOptions, setStateOptions] = useState({
        label: "- Select State -",
        value: ""
    })

    let navigate = useNavigate();

    const [rows, setRows] = useState([]);
    const getAllInvoiceOrders = () => {
        let list_data = {
            page: index,
            size: 15,
            search: filterText,
        };
        getInvoicesList(list_data).then((res) => {
            if (res.errorCode === 0) {
                // res.responsePacket.data.reverse();
                if (index === 0) {
                    setInvoiceOrdersList(res.responsePacket.data);
                    setRows(res.responsePacket.data);
                } else {
                    const invoiceListClone = [
                        ...invoiceOrdersList,
                        ...res.responsePacket.data,
                    ];
                    setInvoiceOrdersList(invoiceListClone);
                    setRows(invoiceListClone);
                }
                setIndex(index + 1);
                setInvoiceOrdersListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                });
            } else {
                toast(res.message);
            }
        });
    };

    useEffect(() => {
        getAllInvoiceOrders();
    }, [filterText])

    useEffect(() => {
        getTermsConditionKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                options?.map((a) => {
                    setCreditInfo({
                        ...creditInfo,
                        terms: a,
                    });
                });
                setTermsOptions(options);
            } else {
                toast(res.message);
            }
        });

        getStateRegionKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    label: d.value.split("-")[1].trim(),
                    value: d.value.split("-")[1].trim()
                }));
                setStateOptions(options);
            } else {
                toast(res.message);
            }
        });
    }, []);

    const getInvoiceDetailsByUUIDs = (id) => {
        getInvoiceDetailsByUUID(id).then((res) => {
            if (res.errorCode === 0) {
                let ddd = res.responsePacket;
                let d = res.responsePacket.itemsList;

                ddd.customerAddresses.map((a) => {
                    if (a.addressType === "Billing") {
                        ddd.billAdd = a;
                    }

                    if (a.addressType === "Shipping") {
                        ddd.shipAdd = a;
                    }
                });

                var tot = JSON.parse(
                    JSON.stringify(res.responsePacket.totalAmount)
                );
                let tot1 = 0;
                let finalTotal = 0;
                let netTax = 0;
                let disTax = 0;
                let disPercent = 0;
                let disAmount = 0;
                let disSubtotal = 0;

                let sub1 = 0;
                d?.map((a) => {
                    sub1 = sub1 + a.amount;
                });
                if (
                    Number(sub1).toFixed(2) !==
                    Number(ddd.subTotalAmount).toFixed(2)
                ) {
                    toast.error("subtotal mismatch");
                }

                var subtot = JSON.parse(JSON.stringify(ddd.subTotalAmount));
                // Discount already applied in rate by backend
                ddd.discountSubTotal = subtot;
                ddd.discountPercent = 0;
                ddd.discountAmount = 0;

                d.map((a) => {
                    a.taxBean.newTax =
                        a.taxBean.taxType + a.taxBean.rate.toString();
                    a.taxBean.disAmount = a.taxBean.amount;
                    a.disItemAmount = a.amount;
                    netTax += a.taxBean.amount;
                    disTax += a.taxBean.disAmount;
                    disSubtotal += a.taxBean.disItemAmount;
                });

                let obj = {};
                for (let i = 0; i < d.length; i++) {
                    if (obj[d[i].taxBean.newTax]) {
                        obj[d[i].taxBean.newTax] += d[i].taxBean.disAmount;
                    } else {
                        obj[d[i].taxBean.newTax] = d[i].taxBean.disAmount;
                    }
                }

                let s1 = ddd?.shippingChargeTaxTitle?.split(" ")[0];
                let s2 = ddd?.shippingChargeTaxTitle?.split(" ")[1];

                let shipTaxTitle = (ddd.shippingChargeTaxTitle2 = s1 + s2);

                setKeys(Object.keys(obj));
                setValues(Object.values(obj));

                let arr = [];
                Object.keys(obj).map((a, i) => {
                    Object.values(obj).map((b, j) => {
                        if (i === j) {
                            return arr.push({ tax: a, value: b });
                        }
                    });
                });

                let z = JSON.parse(JSON.stringify(d));
                z.map((a) => {
                    a.newHsn = a.hsnSac.toString() + "_" + a.taxBean.newTax;
                });

                let obj2 = {};
                for (let i = 0; i < z.length; i++) {
                    if (obj2[z[i].newHsn]) {
                        obj2[z[i].newHsn] += z[i].taxBean.disAmount;
                    } else {
                        obj2[z[i].newHsn] = z[i].taxBean.disAmount;
                    }
                }

                let obj3 = {};

                for (let i = 0; i < z.length; i++) {
                    if (obj3[z[i].newHsn]) {
                        obj3[z[i].newHsn] += z[i].disItemAmount;
                    } else {
                        obj3[z[i].newHsn] = z[i].disItemAmount;
                    }
                }

                setHsnKey(Object.keys(obj2));
                setHsnVal1(Object.values(obj2));
                setHsnVal2(Object.values(obj3));

                let t2 = ddd.totalAmount.toFixed(2).toString()?.split(".")[1];
                if (t2 > 49) {
                    ddd.totalAmount += 1;
                    let a = 100 - t2;
                    ddd.rounding = "+0." + a;
                } else {
                    ddd.rounding = "-0." + t2;
                }

                ddd.netTax = netTax;
                ddd.disTax = disTax;

                ddd.shipValue = ddd.shippingCharges / (1 + ddd.shippingChargeTaxRate * 0.01);
                ddd.shipTaxValue = ddd.shippingCharges - ddd.shipValue;

                ddd.shipValue = ddd.shippingCharges / (1 + ddd.shippingChargeTaxRate * 0.01);
                let zx = (ddd.shipTaxValue = ddd.shippingCharges - ddd.shipValue);
                
                arr.map((a) => {
                    console.log(a)
                    if (a.tax === shipTaxTitle) {
                        a.value = a.value + zx;
                    }
                });
                
                const isShipTaxAdded = arr.find(item => item.tax === shipTaxTitle);
                if (!isShipTaxAdded) {
                    arr.push({
                        tax: shipTaxTitle,
                        value: zx
                    })
                }

                ddd.taxDetail = arr;

                logInvoiceHistory(res.responsePacket.invoiceNo).then((res) => {
                    if (res.errorCode === 0) {
                        const d = res.responsePacket;
                        setLogData(d);
                    } else {
                        toast(res.message);
                    }
                });

                let localDate = new Date(res.responsePacket.salesOrderDate)
                    ?.toISOString()
                    .replace(/T.*/, "")
                    .split("-")
                    .reverse()
                    .join("-");

                let localDate2 = new Date(res.responsePacket.invoiceDate)
                    ?.toISOString()
                    .replace(/T.*/, "")
                    .split("-")
                    .reverse()
                    .join("-");
                let localDate3 = new Date(res.responsePacket?.dueDate ? res.responsePacket?.dueDate : res.responsePacket?.invoiceDate)
                    ?.toISOString()
                    .replace(/T.*/, "")
                    .split("-")
                    .reverse()
                    .join("-");

                res.responsePacket.salesOrderDate = localDate;
                res.responsePacket.invoiceDate = localDate2;
                res.responsePacket.dueDate = localDate3;

                setInvoiceOrderDetail(res.responsePacket);
                setBatchDetails(res.responsePacket?.itemsList.reduce((acc, item) => acc.concat(item), []))
                let org = JSON.parse(localStorage.getItem("orgDetail"));
                setOrgDetail(org);
                if (org?.beanAddress?.state === undefined) {
                    alert("logged In user's organization address not found ");
                }

                let gst12cust = res.responsePacket.customerGstNumber.substring(0, 2);
                let gst12org = org.gstNumber.substring(0, 2);

                let customerAddress;
                res.responsePacket.customerAddresses.map((item) => {
                    if (item.addressType === "Billing") {
                        customerAddress = item.state;
                    }
                })

                if (gst12cust === gst12org) {
                    setTaxType("intra");
                } else {

                    if (customerAddress === orgState) {
                        setTaxType("intra");
                    } else {
                        setTaxType("inter");
                    }
                }
            } else {
                toast(res.message);
            }
        });
    };

    useEffect(() => {
        getAllInvoiceOrders();
        getInvoiceDetailsByUUIDs(id);
    }, [id]);

    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: invoiceOrderDetail?.invoiceNo,
    });

    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setIndex(0);
            setFilterText(value);
        }, 500);
    };

    const filterOptions = [
        { value: "allOrders", label: "allOrders" },
        { value: "isPaid", label: "isPaid" },
        { value: "isPacked", label: "isPacked" },
        { value: "isShipped", label: "isShipped" },
        { value: "eInvoice", label: "eInvoice" },
        { value: "eWay", label: "eWay" },
    ];

    const handleFilter = (e) => {
        if (e.value === "isPaid") {
            var arr1 = rows.filter((data) => data.isPaid);
            setInvoiceOrdersList(arr1);
        }
        if (e.value === "isShipped") {
            var arr1 = rows.filter((data) => data.isShipped);
            setInvoiceOrdersList(arr1);
        }

        if (e.value === "isPacked") {
            var arr3 = rows.filter((data) => data.isPacked);
            setInvoiceOrdersList(arr3);
        }
        if (e.value === "allOrders") {
            var arr3 = rows.filter((data) => data.salesOrderNo);
            setInvoiceOrdersList(arr3);
        }
        if (e.value === "eInvoice") {
            var arr3 = rows.filter((data) => data.einvoiceGenerated);
            setInvoiceOrdersList(arr3);
        }
        if (e.value === "eWay") {
            var arr3 = rows.filter((data) => data.ewayBillGenerated);
            setInvoiceOrdersList(arr3);
        }
    };

    const pdfOptions = [
        { label: "All", value: "All" },
        { label: "Original", value: "Original" },
        { label: "Duplicate", value: "Duplicate" },
        { label: "Triplate", value: "Triplate" },
    ];

    const handleCancelClick = () => {
        getEInvoiceDetail(invoiceOrderDetail.invoiceNo)
            .then((res) => {
                if (res.errorCode === 0) {
                    let d = res.responsePacket;
                    setCancelInfo({
                        ...cancelInfo,
                        irn: d.irn,
                        gst: d.requestId.split("_")[0],
                    });

                    setShow2(true);
                } else {
                    toast.error(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleCancelEInvoice = () => {
        let data = {
            cancel_reason: 1,
            cancel_remarks: cancelInfo.note,
            irn: cancelInfo.irn,
            user_gstin: cancelInfo.gst,
        };

        cancelEInvoice(invoiceOrderDetail.invoiceNo, data)
            .then((res) => {
                if (res.errorCode === 0) {
                    toast.success("E_Invoice Cancelled");
                    handleClose2(false);
                    getInvoiceDetailsByUUIDs(invoiceOrderDetail.recordId);
                } else {
                    toast.error(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleEInvoice = () => {
        setLoader(true);
        if (
            !invoiceOrderDetail.billAdd?.pinCode ||
            invoiceOrderDetail.billAdd?.pinCode === "123456"
        ) {
            toast.error("Improper Customer's pinCode ");
            setLoader(false);
            return;
        }
        if (
            !invoiceOrderDetail.shipAdd?.pinCode ||
            invoiceOrderDetail.shipAdd?.pinCode === "123456"
        ) {
            toast.error("Improper Customer's pinCode ");
            setLoader(false);
            return;
        }
        if (
            !invoiceOrderDetail.shipAdd?.city ||
            !invoiceOrderDetail.billAdd?.city
        ) {
            toast.error("Improper Customer's City ");
            setLoader(false);
            return;
        }
        if (
            !invoiceOrderDetail.shipAdd?.addressLine2 ||
            !invoiceOrderDetail.billAdd?.addressLine2
        ) {
            toast.error("Improper Customer's addressLine2 ");
            setLoader(false);
            return;
        }

        addEInvoice(invoiceOrderDetail.invoiceNo, invoiceOrderDetail)
            .then((res) => {
                if (res.errorCode === 0) {
                    setLoader(false);
                    if (res.responsePacket.message.alert) {
                        toast(res.responsePacket.message.alert);
                    } else {
                        toast.success("eInvoice Generated");
                    }

                    getInvoiceDetailsByUUIDs(invoiceOrderDetail.recordId);
                } else {
                    setLoader(false);
                    toast.error(res.message);
                }
            })
            .catch(() => {
                setLoader(false);
                toast.error("server error");
                return;
            });
    };

    const handleDelete = () => {
        Swal.fire({
            title: "Delete this record ?",
            width: "300px",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes ",
            cancelButtonText: " No",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteInvoice(invoiceOrderDetail.recordId)
                    .then((res) => {
                        if (res.errorCode === 0) {
                            toast.success(res.message);
                        } else {
                            toast.error(res.message);
                        }
                    })
                    .catch(() => {
                        toast.error("server error");
                        return;
                    });
            }
        });
    };

    const handleCreditModal = (id, invoiceId) => {
        getCreditNote2(invoiceId).then((res) => {
            if (res.errorCode === 0) {
                let d = res.responsePacket;
                let dItem = res.responsePacket.creditNoteItemsList;

                let _creditnotesType = dItem.map((item) => {
                    const _creditNoteItemTypeEnum = creditNoteItemTypeEnumOptions.find((obj) => obj.value === item.creditNoteItemTypeEnum);
                    return { ...item, creditNoteItemTypeEnum: _creditNoteItemTypeEnum };
                });

                setEdit(true);
                setShow3(true);
                setCreditInfo({
                    terms: {
                        label: d.creditNoteTermsConditions,
                        value: d.creditNoteTermsConditionId,
                    },
                    recordId: d.recordId,
                    creditNoteNo: d.creditNoteNo,
                    note: d.reference,
                    date: d.creditNoteIssueDate,
                    cNo1: d.creditNoteNoAlt ? d.creditNoteNoAlt : "",
                });

                setInvDetails(d);
                getInvoiceDetailsByUUID(id).then((res) => {
                    if (res.errorCode === 0) {
                        let cItem = res.responsePacket.itemsList;

                        cItem = cItem.map((a) => {
                            dItem.forEach((b) => {
                                if (a.itemUuid === b.itemUuid) {
                                    a.qty = b.quantity;
                                }
                            });
                            return a;
                        });

                        const updatedItemList = cItem.map((item) => {
                            const creditNoteItem = _creditnotesType.find((cnItem) => cnItem.itemUuid === item.itemUuid);
                            return { ...item, creditNoteItemTypeEnum: creditNoteItem ? creditNoteItem.creditNoteItemTypeEnum : undefined };
                        });

                        setItemList((prevItemList) => [
                            ...prevItemList.filter((item) => !cItem.some((ci) => ci.itemUuid === item.itemUuid)),
                            ...updatedItemList,
                        ]);
                    } else {
                        toast(res.message);
                    }
                });
            } else {
                getInvoiceDetailsByUUID(id).then((res) => {
                    if (res.errorCode === 0) {
                        setShow3(true);
                        setInvDetails(res.responsePacket);
                        setItemList(res.responsePacket.itemsList);
                    } else {
                        toast(res.message);
                    }
                });
            }
        });
    };

    const handleQty = (e, i) => {
        const obj = [...itemList];
        let qt = Number(e.target.value);
        if (qt <= obj[i].quantity) {
            obj[i].qty = qt;
            setItemList(obj);
        } else {
        }
    };

    const handlecreditNoteItemTypeEnum = (e, i) => {
        const obj = [...itemList];
        obj[i] = { ...obj[i] || {}, creditNoteItemTypeEnum: e }
        setItemList(obj);
        setCreditInfo({ ...creditInfo, creditNoteItemTypeEnum: e.value });
    }

    const saveCreditNote = () => {
        let subTotal = 0;
        let netTax = 0;
        let arr = itemList.filter((a) => a.qty);

        arr?.map((a) => {
            a.quantity = a.qty;
            a.amount = a.rate * a.qty;
            a.unit = a.unit;
            a.unitId = a.unitId;
            subTotal += a.amount;
            a.taxBean.amount = a.amount * a.taxBean.rate * 0.01;
            netTax += a.taxBean.amount;
            a.creditNoteItemTypeEnum = a?.creditNoteItemTypeEnum?.value;
        });

        if (arr.length === 0) {
            toast("please select atleast 1 item");
            return;
        }

        if (creditInfo.cNo1 === 0 || creditInfo.cNo1 === "") {
            toast.error("Please fill the credit note number.");
            return;
        }

        if (creditInfo.note === 0 || creditInfo.note === "") {
            toast.error("please fill the note.");
            return;
        }

        let creditTotal = subTotal + netTax;

        let data = {
            creditNoteTermsConditionId: creditInfo.terms.value,
            creditNoteTermsConditions: creditInfo.terms.label,

            creditNoteIssueDate: creditInfo.date,
            creditNoteNoAlt: creditInfo.cNo1,

            creditsRemaining: creditTotal,
            isRedeemed: true,
            reference: creditInfo.note,

            roundOffId: 1,
            roundOffTitle: "Round off to nearest zero",

            customerId: invDetails.customerId,
            customerTitle: invDetails.customerTitle,
            invoiceDate: invDetails.invoiceDate,
            invoiceId: invDetails.recordId,
            invoiceNo: invDetails.invoiceNo,
            priceListId: invDetails.priceListId,
            priceListTitle: invDetails.priceListTitle,
            salespersonId: invDetails.salespersonId,
            salespersonTitle: invDetails.salespersonTitle,
            subTotalAmount: subTotal,
            totalAmount: creditTotal,
            totalTaxAmount: netTax,
            creditNoteItemsList: arr,
        };


        if (edit) {
            data.recordId = creditInfo.recordId;
            data.creditNoteNo = creditInfo.creditNoteNo;
        }
        setShowSpinner(true);
        if (edit) {
            editCreditNote(creditInfo.recordId, data).then((res) => {
                if (res.errorCode === 0) {
                    handleClose3();
                    toast.success(res.message);
                    setShowSpinner(false);
                } else {
                    toast.error(res.message);
                    setShowSpinner(false);
                }
            });
        } else {
            addCreditNote(data)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast.success(res.message);
                        handleClose3();
                        setShowSpinner(false);
                    } else {
                        toast.error(res.message);
                        setShowSpinner(false);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        }
        setShowSpinner(false);
    };

    const createEWayBill = (invoiceNo) => {
        generateEWay(invoiceNo).then((res) => {
            if (res.errorCode === 0) {
                getInvoiceDetailsByUUIDs(invoiceOrderDetail.recordId);
                toast.success(res.message);
            } else {
                toast.error(res.message);
            }
        });
    };

    const handleEWayVehicleNumber = (e) => {
        const { name, value } = e.target;
        setUpdateVehicleObj((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleUpdateVehicleInEWay = () => {
        if (!updateVehicleObj.vehicleNumber || updateVehicleObj.vehicleNumber === "") {
            toast("Please enter Vehicle Number!", { id: "UpdateWayBill" })
            return;
        }
        if (!updateVehicleObj.placeOfChange || updateVehicleObj.placeOfChange === "") {
            toast("Please enter place of change!", { id: "UpdateWayBill" })
            return;
        }
        if (!updateVehicleObj.reason.value || updateVehicleObj.reason.value === "") {
            toast("Please select reason for updating the e-way bill!", { id: "UpdateWayBill" })
            return;
        }
        if (!updateVehicleObj.placeOfChangeState.value || updateVehicleObj.placeOfChangeState.value === "") {
            toast("Please select state for updating the e-way bill!", { id: "UpdateWayBill" })
            return;
        }

        const payload = {
            vehicle_number: updateVehicleObj.vehicleNumber,
            reason_code_for_vehicle_updation: updateVehicleObj.reason.value,
            place_of_consignor: updateVehicleObj.placeOfChange,
            state_of_consignor: updateVehicleObj.placeOfChangeState.value,
        }

        callPostApi(UPDATE_EWAY_VEHICLE_NUMBER_POST.replaceAll("{invoiceNo}", invoiceOrderDetail?.invoiceNo), payload, {}, (response) => {
            if (response.errorCode === 0) {
                toast.success(response.message);
                getInvoiceDetailsByUUIDs(invoiceOrderDetail.recordId);
                setVehicleNumber("");
                setEwayModal(false);
                setUpdateVehicleObj(updateVehicleEmptyObj);
            } else {
                toast.error(response.message)
            }
        }, (err) => {
            console.error("Catch Error :: ", err)
        })
    }

    const handleExtendedEwayBill = () => {

        if (!reasonForExtension.remark || reasonForExtension.remark === "") {
            toast("Please enter  remark!", { id: "remark" })
            return;
        }
        if (!reasonForExtension.reason.value || reasonForExtension.reason.value === "") {
            toast("Please select reason!", { id: "reason" })
            return;
        }
        if (!reasonForExtension.currentPinCode || reasonForExtension.currentPinCode === "") {
            toast("Please enter currentPincode!", { id: "currentPinCode" })
            return;
        }
        if (!reasonForExtension.currentPlace || reasonForExtension.currentPlace === "") {
            toast("Please enter currentPlace!", { id: "currentPlace" })
            return;
        }
        if (!reasonForExtension.approximateDistance || reasonForExtension.approximateDistance === "") {
            toast("Please enter  approximateDistance!", { id: "approximateDistance" })
            return;
        }
        if (!reasonForExtension.currentState.value || reasonForExtension.currentState.value === "") {
            toast("Please enter currentState!", { id: "currentState" })
            return;
        }
        if (!reasonForExtension.vehicleNo || reasonForExtension.vehicleNo === "") {
            toast("Please enter vehicleNo!", { id: "vehicleNo" })
            return;
        }

        const reqObj = {
            extend_remarks: reasonForExtension.remark,
            extend_validity_reason: reasonForExtension.reason.value,
            from_pincode: reasonForExtension.currentPinCode,
            place_of_consignor: reasonForExtension.currentPlace,
            remaining_distance: reasonForExtension.approximateDistance,
            state_of_consignor: reasonForExtension.currentState.value,
            vehicle_number: reasonForExtension.vehicleNo
        }

        callPostApi(EXTEND_EWAY_BILL_POST.replaceAll("{invoiceNo}", invoiceOrderDetail?.invoiceNo), reqObj, {}, (response) => {
            if (response.errorCode === 0) {
                toast.success(response.responsePacket.results.message);
                getInvoiceDetailsByUUIDs(invoiceOrderDetail.recordId);
                setShowExtendedEwayBill(false);
                setReasonForExtension(ExtendedEwayBillObj);
            } else {
                toast.error(response.message)
            }
        }, (err) => {
            console.error("Catch Error :: ", err)
        })

    }

    const handleCloseUpdateVehicleModal = () => {
        setVehicleNumber("");
        setEwayModal(false);
    }

    const handleCloseExtendedEwayBillModal = () => {
        setShowExtendedEwayBill(false);
    }

    const handleSelectForCancelEwayBill = (e) => {
        setCancelEwayObj((prev) => ({
            ...prev,
            reason: e
        }))
    }

    const handleEwayBillCancelReason = (e) => {
        const { value } = e.target;
        setCancelEwayObj((prev) => ({
            ...prev,
            remark: value
        }))
    }

    const handleCancelEwayBill = () => {
        if (cancelEwayObj.reason.value === "") {
            toast("Please select a reason for cancel E-way bill!", { id: "EwayBill" });
            return;
        }
        const payload = {
            reason_of_cancel: cancelEwayObj.reason.value,
            cancel_remark: cancelEwayObj.remark
        }
        callPostApi(CANCEL_EWAY_BILL_POST.replaceAll("{invoiceNo}", invoiceOrderDetail?.invoiceNo), payload, {}, (response) => {
            if (response.errorCode === 0) {
                getInvoiceDetailsByUUIDs(invoiceOrderDetail.recordId);
                setShowCancelModal(false);
                setCancelEwayObj(cancelEwayEmptyObj);
                toast.success(response.message);
            } else {
                toast.error(response.message)
            }
        }, (err) => {
            console.error("Catch Error :: ", err)
        })
    }

    const handleSelectUpdateEwayVehicle = (e) => {
        setUpdateVehicleObj((prev) => ({
            ...prev,
            reason: e
        }))
    }
    const handleSelectExtendedEwayBill = (e) => {
        setReasonForExtension((prev) => ({
            ...prev,
            reason: e
        }))
    }

    const handleSelectConsignment = (e) => {
        setReasonForExtension((prev) => ({
            ...prev,
            consignment: e
        }))
    }

    const handleSelectStateExtendedEway = (e) => {
        setReasonForExtension((prev) => ({
            ...prev,
            currentState: e
        }))
    }

    const handleExtendedInputChange = (e) => {
        const { name, value } = e.target;
        setReasonForExtension((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleSelectStateInEway = (e) => {
        setUpdateVehicleObj((prev) => ({
            ...prev,
            placeOfChangeState: e
        }))
    }

    return (
        <>
            <div
                className="list-column column d-print-none"
                style={{ width: "300px" }}
            >
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <button
                            className="newListBtn"
                            onClick={() =>
                                navigate(`/directInvoices`, {
                                    state: { directInvoice: true },
                                })
                            }
                        >
                            <AddIcon />
                            New
                        </button>
                        <div className="input-group paginationSearchInput listSearch">
                            <div className="input-group-prepend">
                                <span
                                    className="input-group-text"
                                    id="basic-addon1"
                                >
                                    <SearchRoundedIcon />
                                </span>
                            </div>
                            <input
                                autoComplete="off"
                                className="form-control"
                                type="text"
                                placeholder="Search..."
                                onChange={handleSearch}
                            />
                        </div>
                    </div>
                </div>

                <div className="scroll-y fill body scrollbox list-body">
                    <div className="table-responsive overflow-initial">
                        <table
                            id="ember7912"
                            className="table zi-table ember-view header-fixed"
                        >
                            {invoiceOrdersList && (invoiceOrdersList?.length > 0 ? (
                                <tbody>
                                    {invoiceOrdersList?.map((d, i) => (
                                        <tr
                                            key={i}
                                            className={`listTr ${id === d.recordId ? "activeRecord" : ""}`}
                                        >
                                            <td>
                                                <Link
                                                    to={`/invoices/${d.recordId}`}
                                                    className={`${id === d.recordId ? "text-primary" : "text-grey"}`}
                                                >
                                                    <span className="titleTr">
                                                        {d.customerTitle}
                                                    </span>
                                                    <span className="d-flex justify-content-between">
                                                        <span>{d.invoiceNo}</span>
                                                        <span>₹{" "} {d.amount?.toFixed(2)}</span>
                                                        <span>{d.invoiceDate}</span>
                                                    </span>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                    {
                                        invoiceOrdersListDetails &&
                                        invoiceOrdersListDetails?.recordsTotal >
                                        invoiceOrdersList?.length && (
                                            <div className="pt-3">
                                                <button
                                                    className="btn mx-auto newListBtn"
                                                    onClick={getAllInvoiceOrders}
                                                >
                                                    Load More
                                                </button>
                                            </div>

                                        )
                                    }
                                </tbody>
                            ) : (
                                <div className="my-3 text-black text-center">
                                    No Data Available!
                                </div>
                            ))}
                        </table>
                    </div>
                </div>
            </div>
            <div className="column content-column" style={{ left: "301px" }}>
                <div className="header no-border d-flex align-items-center p-4">
                    <div className="listTopHeading">
                        <div className="btn-toolbar over-flow text-muted font-xlarge pb-0">
                            {invoiceOrderDetail?.invoiceNo}
                            &nbsp;&nbsp;
                            <div
                                className="cursor-pointer text-primary font-size-15"
                                onClick={() =>
                                    navigate(
                                        `/salesorders/${invoiceOrderDetail.salesOrderId}`
                                    )
                                }
                            >
                                ( {invoiceOrderDetail?.salesOrderNo} )
                            </div>
                        </div>
                    </div>
                    <a
                        className="over-flow header-title text-uppercase"
                        style={{ fontSize: "x-large" }}
                    >
                        &nbsp;
                    </a>
                    <div className="btn-toolbar d-flex justify-content-end align-items-center">
                        &nbsp;&nbsp;
                        {invoiceOrderDetail?.einvoicePdf && (
                            <a
                                href={invoiceOrderDetail?.einvoicePdf}
                                target="_blank"
                                download
                                className="successBtn mr-2"
                            >
                                <InsertDriveFileIcon /> E-Invoice
                            </a>
                        )}
                        {invoiceOrderDetail?.ewayBillPdf && (
                            <a
                                href={`https://${invoiceOrderDetail?.ewayBillPdf}`}
                                target="_blank"
                                download
                                className="successBtn mr-2"
                            >
                                <InsertDriveFileIcon /> E-Way Bill
                            </a>
                        )}
                        <Dropdown className="dropdownSection">
                            <Dropdown.Toggle>Invoice</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <>
                                    {invoiceOrderDetail?.isShipped ||
                                        invoiceOrderDetail?.einvoiceGenerated ||
                                        invoiceOrderDetail?.ewayBillGenerated ? (
                                        <></>
                                    ) : (
                                        <>
                                            <div
                                                className="dropdown-option"
                                                onClick={() => navigate(`/invoiceEdit/`, { state: { invoiceId: invoiceOrderDetail.recordId, invoiceEdit: true } })}
                                            >
                                                <EditIcon /> Edit
                                            </div>
                                        </>
                                    )}
                                    <div
                                        className="dropdown-option"
                                        onClick={handlePrint}
                                    >
                                        <LocalPrintshopOutlinedIcon /> Print
                                    </div>

                                    {!invoiceOrderDetail?.isPaid && (
                                        <div
                                            className="dropdown-option"
                                            onClick={() => navigate(`/SalesPayment/${invoiceOrderDetail.recordId}`, { state: { id: invoiceOrderDetail.recordId } })}
                                        >
                                            <PaymentIcon /> Pay
                                        </div>
                                    )}
                                    <div
                                        className="dropdown-option"
                                        onClick={() =>
                                            handleCreditModal(
                                                invoiceOrderDetail.recordId,
                                                invoiceOrderDetail.invoiceNo
                                            )
                                        }
                                    >
                                        <AddIcon />
                                        Credit Note
                                    </div>

                                    {invoiceOrderDetail?.einvoiceGenerated ||
                                        invoiceOrderDetail?.ewayBillGenerated ? (
                                        <></>
                                    ) : (
                                        <div
                                            className="dropdown-option"
                                            onClick={() => handleDelete()}
                                        >
                                            <DeleteIcon /> Delete
                                        </div>
                                    )}
                                </>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown className="dropdownSection">
                            <Dropdown.Toggle>E-Invoice</Dropdown.Toggle>
                            <Dropdown.Menu>
                                <>
                                    <div
                                        className="dropdown-option"
                                        onClick={() => handleEInvoice()}
                                    >
                                        <AddIcon />
                                        New
                                    </div>

                                    {invoiceOrderDetail?.einvoicePdf && (
                                        <div
                                            className="dropdown-option"
                                            onClick={() => handleCancelClick()}
                                        >
                                            <ClearIcon /> Cancel IRN
                                        </div>
                                    )}
                                </>
                            </Dropdown.Menu>
                        </Dropdown>
                        <Dropdown className="dropdownSection">
                            <Dropdown.Toggle>E-Way</Dropdown.Toggle>
                            <Dropdown.Menu>
                                {invoiceOrderDetail?.ewayBillGenerated ? (<div>
                                    <div
                                        className="dropdown-option"
                                        onClick={() => setEwayModal(true)}
                                    >
                                        <LocalShippingIcon /> Update Vehicle Number
                                    </div>
                                    <div
                                        className="dropdown-option"
                                        onClick={() => setShowExtendedEwayBill(true)}
                                    >
                                        <TbArrowsDiagonal style={{ fontSize: '1.3em' }} />  Extended Eway Bill
                                    </div>
                                    <div
                                        className="dropdown-option"
                                        onClick={() => setShowCancelModal(true)}
                                    >
                                        <CloseIcon /> Cancel
                                    </div>
                                </div>) : (<div
                                    className="dropdown-option"
                                    onClick={() => createEWayBill(invoiceOrderDetail.invoiceNo)}
                                >
                                    <AddIcon /> New Bill
                                </div>)}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                <Tabs
                    selectedIndex={tabIndex}
                    onSelect={(index) => setTabIndex(index)}
                    className="upperTabs"
                >
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                        <Tab>Batch Details</Tab>
                    </TabList>

                    <TabPanel>
                        {loader ? <LinearProgress /> : <></>}
                        {invoiceOrderDetail && invoiceOrderDetail && orgDetail && orgDetail ? (
                            <ViewPdf
                                orderDetail={invoiceOrderDetail}
                                itemList={invoiceOrderDetail?.itemsList}
                                orgDetail={orgDetail}
                                taxType={taxType}
                                componentRef={componentRef}
                                pdfType={"invoice"}
                                keys={keys}
                                values={values}
                                hsnKey={hsnKey}
                                hsnVal1={hsnVal1}
                                hsnVal2={hsnVal2}
                            />
                        ) : (
                            <></>
                        )}
                    </TabPanel>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox">
                            <table>
                                {logData.length === 0 ? (
                                    "No Changes Found"
                                ) : (
                                    <tr>
                                        <td style={{ width: "100px" }}>Date</td>
                                        <td>Changes</td>
                                    </tr>
                                )}
                                {logData.length > 0 &&
                                    logData?.map((a, i) => {
                                        return (
                                            <Fragment key={i}>
                                                <tr>
                                                    <td
                                                        style={{ verticalAlign: "top", width: "80px" }}
                                                    >
                                                        {a?.transactionDate?.substring(0, 10)}
                                                        :&nbsp;&nbsp;
                                                        <br />
                                                        Time:
                                                        {a?.transactionDate?.split("T")[1].substring(0, 5)}
                                                    </td>
                                                    <td>
                                                        <div dangerouslySetInnerHTML={{ __html: a?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                        {/* {a?.message.split("\n").map((b, j) => (
                                                    <tr key={j}>
                                                        {b.includes("\t") ? <div style={{ marginLeft: "20px" }}>{b}</div> : b.includes("\t\t") ? <div style={{ marginLeft: "40px" }}>{b}</div> : b}
                                                    </tr>
                                                ))} */}
                                                    </td>
                                                </tr>
                                                <hr />
                                            </Fragment>
                                        );
                                    })}
                            </table>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className="ember-view scroll-y noscroll-x fill body scrollbox py-3">
                            <table
                                style={{
                                    width: '90%',
                                    tableLayout: 'fixed',
                                    clear: 'both',
                                }}
                                className='pcs-label'
                                id='itemTable'
                                cellSpacing={0}
                                cellPadding={0}
                                border='1px solid black'
                                ref={componentRef}
                            >
                                <thead>
                                    <tr>
                                        <td style={{ width: '10%' }}>S.No.</td>
                                        <td style={{ width: '100%' }}>Item</td>
                                    </tr>

                                </thead>
                                <tbody >
                                    {batchDetails.map((item, index) => {
                                        return (
                                            <tr style={{ marginLeft: "8px" }} key={index}>
                                                <td><div style={{ width: "100%", marginLeft: "20px" }}>{index + 1}</div></td>
                                                <td>
                                                    <span style={{ borderBottom: "1px solid black" }}>{item.itemTitle}</span>
                                                    <table style={{
                                                        width: '100%',
                                                        tableLayout: 'fixed',
                                                        clear: 'both',
                                                        marginTop: "10px"
                                                    }}
                                                        className='pcs-label'
                                                        id='itemTable'
                                                        cellSpacing={0}
                                                        cellPadding={0}
                                                        border='1px solid black'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: "17%" }}>Batch No</th>
                                                                <th style={{ width: "12%" }}>Batch Qty</th>
                                                                <th style={{ width: "12%" }}>Mfg Date</th>
                                                                <th style={{ width: "12%" }}>Exp Date</th>
                                                                <th style={{ width: "10%" }}>Store</th>
                                                                <th style={{ width: "7%" }}>Rack</th>
                                                                <th style={{ width: "7%" }}>Cell</th>
                                                                <th style={{ width: "7%" }}>Pallete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontWeight: "400" }}>
                                                            <>
                                                                {item?.beanStockTransferBatchList.map((e) => {
                                                                    return <tr key={index}>
                                                                        <td>{e?.batchNumber}</td>
                                                                        <td>{e?.batchQuantitySelected}</td>
                                                                        <td>{e?.batchManufacturingDate}</td>
                                                                        <td>{e?.batchExpiredDate}</td>
                                                                        <td>{e?.storeTitle}</td>
                                                                        <td>{e?.rackTitle}</td>
                                                                        <td>{e?.cellTitle}</td>
                                                                        <td>{e?.palletTitle}</td>
                                                                    </tr>
                                                                })}

                                                            </>

                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </TabPanel>
                </Tabs>
                <br />
            </div>
            <Modal show={show2} onHide={handleClose2} size="sm">
                <Modal.Body>
                    <table>
                        <tr>
                            <td>Note:</td>
                            <td>
                                <input
                                    className=" form-control "
                                    value={cancelInfo.note}
                                    onChange={(e) =>
                                        setCancelInfo({
                                            ...cancelInfo,
                                            note: e.target.value,
                                        })
                                    }
                                />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" onClick={handleCancelEInvoice}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={show3} onHide={handleClose3} size="md" >
                <Modal.Body>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: "16px",
                        }}
                    >
                        <span>{edit ? "EDIT" : "NEW"} CREDIT </span>
                        <span>{invDetails.invoiceNo}</span>
                    </div>
                    <br />

                    <table style={{ width: "100%" }}>
                        <tr>
                            <td style={{ width: "100px" }}>WAREHOUSE TITLE</td>
                            <td style={{ width: "100px" }}>
                                <input
                                    disabled="true"
                                    type="text"
                                    className="form-control"
                                    value={invoiceOrderDetail?.warehouseTitle}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "100px" }}>TERMS</td>
                            <td style={{ width: "100px" }}>
                                <Select
                                    options={termsOptions}
                                    value={creditInfo.terms}
                                    onChange={(e) =>
                                        setCreditInfo({ ...creditInfo, terms: e })
                                    }
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>DATE</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    type="date"
                                    value={creditInfo.date}
                                    className="form-control"
                                    onChange={(e) =>
                                        setCreditInfo({
                                            ...creditInfo,
                                            date: e.target.value,
                                        })
                                    }
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>CREDITNO.</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    value={creditInfo.cNo1}
                                    className="form-control"
                                    onChange={(e) =>
                                        setCreditInfo({
                                            ...creditInfo,
                                            cNo1: e.target.value,
                                        })
                                    }
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>NOTE</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    value={creditInfo.note}
                                    className="form-control"
                                    onChange={(e) =>
                                        setCreditInfo({
                                            ...creditInfo,
                                            note: e.target.value,
                                        })
                                    }
                                />
                            </td>
                        </tr>
                    </table>
                    <br />
                    <hr />
                    <div className="table-responsive">
                        <table class="table table-bordered" style={{ marginBottom: '120px' }}>
                            <thead>
                                <tr>
                                    <th scope="col">S NO.</th>
                                    <th scope="col">ITEMS</th>
                                    <th scope="col" style={{ width: '70px' }}>QTY</th>
                                    <th scope="col">TYPE</th>
                                    <th scope="col" style={{ width: '110px' }}>INVOICED QTY</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: "#212529" }}>
                                {itemList &&
                                    itemList?.map((a, i) => {
                                        return (
                                            <tr key={i}>
                                                <td scope="row">{i + 1}</td>
                                                <td >
                                                    {a.itemTitle}
                                                </td>
                                                <td >
                                                    <input
                                                        autoComplete="off"
                                                        className="form-control"
                                                        value={a.qty}
                                                        min={0}
                                                        type="number"
                                                        onChange={(e) =>
                                                            handleQty(e, i)
                                                        }
                                                    />
                                                </td>
                                                <td >
                                                    <Select
                                                        options={creditNoteItemTypeEnumOptions}
                                                        value={a?.creditNoteItemTypeEnum}
                                                        onChange={(e) => { handlecreditNoteItemTypeEnum(e, i) }}
                                                    />
                                                </td>
                                                <td className="text-end">
                                                    <input className="bg-white rounded" style={{ width: '54px', padding: '7px 9px', border: '1px solid #ccc' }} value={a.quantity} disabled />
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="contained" onClick={saveCreditNote} className="d-flex align-item-center" disabled={showSpinner}>
                        {showSpinner ? (
                            <Spinner
                                disabled={showSpinner}
                                className="costomLoader mr-2"
                                animation="border"
                                size="sm"
                            />
                        ) : (
                            " Save"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={ewayModal} onHide={handleCloseUpdateVehicleModal} size="sm">
                <Modal.Body>
                    <table>
                        <tr>
                            <td>Vehicle Number *</td>
                            <td>
                                <input
                                    className=" form-control"
                                    name="vehicleNumber"
                                    value={updateVehicleObj.vehicleNumber}
                                    onChange={handleEWayVehicleNumber}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Select Reason *</td>
                            <td>
                                <Select
                                    className=""
                                    value={updateVehicleObj.reason}
                                    options={updateVehicleEwayOptions}
                                    onChange={handleSelectUpdateEwayVehicle}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Place of change *</td>
                            <td>
                                <input
                                    className=" form-control"
                                    name="placeOfChange"
                                    value={updateVehicleObj.placeOfChange}
                                    onChange={handleEWayVehicleNumber}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Place of change State *</td>
                            <td>
                                <Select
                                    value={updateVehicleObj.placeOfChangeState}
                                    options={stateOptions}
                                    onChange={handleSelectStateInEway}
                                />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" onClick={() => handleUpdateVehicleInEWay()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showExtendedEwayBill} onHide={handleCloseExtendedEwayBillModal} size="sm">
                <Modal.Body>
                    <table>
                        <tr>
                            <td>Reason For Extension *</td>
                            <td>
                                <Select
                                    className=""
                                    value={reasonForExtension.reason}
                                    options={extensionOptions}
                                    onChange={handleSelectExtendedEwayBill}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Remarks *</td>
                            <td>
                                <input
                                    className=" form-control"
                                    name="remark"
                                    value={reasonForExtension.remark}
                                    onChange={handleExtendedInputChange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Current Place *</td>
                            <td>
                                <input
                                    className=" form-control"
                                    name="currentPlace"
                                    value={reasonForExtension.currentPlace}
                                    onChange={handleExtendedInputChange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Current Pincode *</td>
                            <td>
                                <input
                                    className=" form-control"
                                    name="currentPinCode"
                                    value={reasonForExtension.currentPinCode}
                                    onChange={handleExtendedInputChange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td> Current State *</td>
                            <td>
                                <Select

                                    value={reasonForExtension.currentState}
                                    options={stateOptions}
                                    onChange={handleSelectStateExtendedEway}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Approximate Distance (in km) *</td>
                            <td>
                                <input
                                    className="form-control"
                                    name="approximateDistance"
                                    value={reasonForExtension.approximateDistance}
                                    onChange={handleExtendedInputChange}
                                />
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <FaLink onClick={() => window.open('https://einvoice1.gst.gov.in/Others/GetPinCodeDistance')} className="cursor-pointer" style={{ fontSize: "17px", color: "blue" }} />
                            </td>
                        </tr>
                        {/* <tr>
                            <td> Consignment *</td>
                            <td>
                                <Select
                                    value={reasonForExtension.consignment}
                                    options={consignmentOptions}
                                    onChange={handleSelectConsignment}
                                />
                            </td>
                        </tr> */}
                        <tr>
                            <td>Vehicle No *</td>
                            <td>
                                <input
                                    className=" form-control"
                                    name="vehicleNo"
                                    value={reasonForExtension.vehicleNo}
                                    onChange={handleExtendedInputChange}
                                />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" onClick={() => handleExtendedEwayBill()}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)} size="sm">
                <Modal.Body>
                    <table>
                        <tr>
                            <td>Select Reason:</td>
                            <td>
                                <Select
                                    className=""
                                    value={cancelEwayObj.reason}
                                    options={ewayBillCancelReasonOptions}
                                    onChange={handleSelectForCancelEwayBill}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Remarks:</td>
                            <td>
                                <input
                                    className=" form-control"
                                    value={cancelEwayObj.remark}
                                    onChange={handleEwayBillCancelReason}
                                />
                            </td>
                        </tr>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" onClick={handleCancelEwayBill}>
                        Yes
                    </Button>
                    <Button variant="contained" onClick={() => setShowCancelModal(false)}>
                        No
                    </Button>
                </Modal.Footer>
            </Modal>
            <Toaster />
        </>
    );
};

export default InvoiceView;
